// @ts-nocheck
(function () {
  "use strict";

  const APP_SLUG = "pw_store";
  const APP_VERSION = "1.3.0";

  function sleep(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function toBoolean(value) {
    if (value === null || value === undefined) return false;
    if (typeof value === "boolean") return value;
    return String(value).toLowerCase() === "true";
  }

  function getFromAppFlag() {
    try {
      const params = new URLSearchParams(window.location.search || "");
      return toBoolean(
        params.get("from_app") ??
          params.get("fromApp") ??
          params.get("from_App") ??
          sessionStorage.getItem("fromApp")
      );
    } catch (e) {
      return false;
    }
  }

  function getToken() {
    try {
      const params = new URLSearchParams(window.location.search || "");
      return params.get("token") || params.get("TOKEN") || params.get("Token") || localStorage.getItem("pw-sync-token");
    } catch (e) {
      return null;
    }
  }

  function getPwUserIdFromToken(token) {
    try {
      if (!token) return null;
      const payload = JSON.parse(atob(String(token).split(".")[1]));
      return payload?.data?._id != null ? String(payload.data._id) : null;
    } catch (e) {
      return null;
    }
  }

  function getFromPage() {
    try {
      const url = new URL(window.location.href);
      ["token", "TOKEN", "Token", "random_id", "randomId", "random_Id"].forEach(function (key) {
        url.searchParams.delete(key);
      });
      return url.pathname + (url.search || "");
    } catch (e) {
      return "/pages/authenticate";
    }
  }

  function getLandingPage() {
    try {
      const params = new URLSearchParams(window.location.search || "");
      const raw = params.get("redirect_url") || params.get("redirectUrl") || "/";
      let path = decodeURIComponent(raw).replace(/^https?:\/\/[^/]+/, "");
      if (!path.startsWith("/")) path = "/" + path;
      return path || "/";
    } catch (e) {
      return "/";
    }
  }

  function getAppVersionName() {
    try {
      const raw = sessionStorage.getItem("app_version_name");
      if (!raw) return null;
      const parsed = parseInt(String(raw), 10);
      return Number.isFinite(parsed) ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function resolveAnalyticsBaseUrl() {
    const shopUrl = String(window.__PW_SHOP_URL__ || "").toLowerCase();
    const host = String(window.location.hostname || "").toLowerCase();
    const isStage =
      shopUrl.includes("marketplace-stage") ||
      host.includes("marketplace-stage") ||
      (host.includes("stage") && host.includes("physicswallah"));
    return isStage
      ? "https://analytics-api-stage.penpencil.co"
      : "https://analytics-api.penpencil.co";
  }

  function buildAttrs(token, extra) {
    const gtm = window.__GTM_CONFIG__ || {};
    const customer = window.__CUSTOMER_DATA__ || {};
    const pwUserId = getPwUserIdFromToken(token) || (customer.pw_user_id != null ? String(customer.pw_user_id) : null);
    const attrs = {
      platform: gtm.platform || "web",
      organisation_name: gtm.organisation_name || "pw",
      business_unit: gtm.business_unit || "pw_store",
      page_url: window.location.origin + window.location.pathname,
      page_name: "authenticate",
      is_logged_in: Boolean(window.hasCustomer),
      from_app: getFromAppFlag(),
      user_id: customer.customerId || null,
      pw_user_id: pwUserId,
      cohort_id: customer.cohort_id || null,
      cohort_name: customer.cohort_name || null,
      timestamp: new Date().toISOString(),
    };
    const appVersion = getAppVersionName();
    if (appVersion != null) attrs.app_version_name = appVersion;
    if (extra && typeof extra === "object") {
      Object.keys(extra).forEach(function (key) {
        attrs[key] = extra[key];
      });
    }
    return attrs;
  }

  function mergeRequired(attrs) {
    try {
      if (window.PWTrackerRequiredAttrs && typeof window.PWTrackerRequiredAttrs.getOrCreate === "function") {
        const required = window.PWTrackerRequiredAttrs.getOrCreate() || {};
        Object.keys(required).forEach(function (key) {
          if (attrs[key] == null || attrs[key] === "") attrs[key] = required[key];
        });
        if (typeof window.PWTrackerRequiredAttrs.touchSessionForInternalEvent === "function") {
          attrs.session_id = window.PWTrackerRequiredAttrs.touchSessionForInternalEvent();
        }
      }
    } catch (e) {}
    return attrs;
  }

  function ensureInit(token) {
    if (!window.PWLightTrackerJS || typeof window.PWLightTrackerJS.init !== "function") return false;
    try {
      const pwUserId = getPwUserIdFromToken(token);
      const opts = {
        clientId: "5eb393ee95fab7468a79d189",
        appName: APP_SLUG,
        appVersion: APP_VERSION,
        subOrgId: "SUB-PWST002",
        enableLogging: true,
        baseUrl: resolveAnalyticsBaseUrl(),
        name: "anonymous",
      };
      if (pwUserId) opts.userId = pwUserId;
      window.PWLightTrackerJS.init(opts);
      return true;
    } catch (e) {
      return false;
    }
  }

  async function waitTracker(ms) {
    const start = Date.now();
    while (Date.now() - start < ms) {
      if (window.PWLightTrackerJS && typeof window.PWLightTrackerJS.logEvent === "function") return true;
      await sleep(40);
    }
    return !!(window.PWLightTrackerJS && typeof window.PWLightTrackerJS.logEvent === "function");
  }

  async function send(eventName, token, extra) {
    if (!(await waitTracker(5000))) return false;
    ensureInit(token);
    let payload = mergeRequired(buildAttrs(token, extra));
    try {
      payload.user_agent = navigator.userAgent || "";
      payload.referrer = document.referrer || "";
    } catch (e) {
      payload.user_agent = payload.user_agent || "";
      payload.referrer = payload.referrer || "";
    }
    if (!payload.event_id) {
      payload.event_id = "evt_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2, 10);
    }
    try {
      if (typeof window.PWLightTrackerJS.trackImmediate === "function") {
        window.PWLightTrackerJS.trackImmediate(eventName, payload);
      } else {
        window.PWLightTrackerJS.logEvent(eventName, payload);
      }
      if (typeof window.PWLightTrackerJS.flush === "function") window.PWLightTrackerJS.flush();
      return true;
    } catch (e) {
      return false;
    }
  }

  async function trackOpened(opts) {
    const options = opts || {};
    const token = options.token || getToken();
    return send("internal_pwst_authenticate_page_opened", token, {
      page_subtype: "multipass",
      from_page: options.fromPage || getFromPage(),
      landing_page: options.landingPage || getLandingPage(),
      status: "opened",
    });
  }

  async function trackRedirect(opts) {
    const options = opts || {};
    const token = options.token || getToken();
    const status = options.status || "success";
    return send("internal_pwst_authenticate_page_redirect", token, {
      page_subtype: "multipass_redirect",
      from_page: options.fromPage || getFromPage(),
      landing_page: options.landingPage || getLandingPage(),
      status: status,
      error_message: options.errorMessage || null,
      login_message: status === "success" ? "Login success" : options.errorMessage || "Login failure",
    });
  }

  window.PWAuthenticateEvents = {
    trackOpened: trackOpened,
    trackRedirect: trackRedirect,
    getFromPage: getFromPage,
    getLandingPage: getLandingPage,
  };
})();
